import React from "react";
import "../TechinalSpecification/TechinalSpecification.css";
import Icon from "./../../images/ArrowLongWhite.svg";

const TechinalSpecificationMK2 = () => {
  const array = [
    {
      head: "Synth voice Features",
      sub: [
        {
          key: "",
          message:
            "Fully analog signal path\n2x analog oscillators\nContinuously variable waveform\nThru-zero frequency modulation\nHard-sync\nFilter overdrive\n1x 3-pole multi-mode filter\nContinuously variable filter color\n1x Main ADSR envelope\nSoft overdrive",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    },
    {
      head: "Modulation Features",
      sub: [
        {
          key: "Controls",
          message: "13x dedicated AD envelopes 20x dedicated modulator",
          flag: true
        },
        {
          key: "Modulator",
          message:
            "5 waveforms\nType settings : Free/Synced/Audio-Rate\nAudio-Rate anti-aliased, quantized to OSC1\nFree from 0.1 to 80 seconds",
          flag: true
        },
        {
          key: "Envelope",
          message: "Attack-Decay segment from 10us to 20s",
          flag: true
        }
      ]
    },
    {
      head: "Sequencer",
      sub: [
        {
          key: "",
          message:
            "Up to 64 step per pattern\n1024PPQN automations\nIndividual length/scale/beat-division per pattern\nIndividual microshift/ratchet/probability per\nstep\nSwing/Slide/Accent\nCopy/paste anything\nUndo/Redo anything\nMod Note mode\nFast, clock independent project Load/Save",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    },

    {
      head: "Randomizer",
      sub: [
        {
          key: "",
          message:
            "Quantized note randomizer\nRanged parameter automation randomizer\nStep randomizer\nMod note randomizer\nMicroshift/Probability/Ratchet randomizer",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    },

    {
      head: "Storage",
      sub: [
        {
          key: "",
          message:
            "Unlimited projects in SD card\n64 patterns with patch memory per projects\nUnlimited parameter automation per pattern\n40 mod note per projects",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    },

    {
      head: "Hardware",
      sub: [
        {
          key: "",
          message:
            "23x transilluminated RGB potentiometer\n24x illuminated silent mechanical switch\n23x 808-style switch\nMIDI In/Out/Thru\n1x 1/4” balanced main audio out jack\n2x 1/8” eurorack Clock/Reset input\nFlash-EEPROM upgradable OS\nMIDI Device USB-C port\nMIDI Host USB-C port",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    },
    {
      head: "Outputs",
      sub: [
        {
          key: "Stereo audio outputs",

          message: "Output level: +15dBu maximum\nOutput impedance: 200 Ohm\nHeadphone up to 80 Ohm",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    },
    {
      head: "Electrical Specification",
      sub: [
        {
          key: "",
          message:
            "Unit consumption: 7W typical\nLow power mode for USB supply\nHigh-quality power supply included\nRecommanded power supply: 5V DC, 2A",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    },
    {
      head: "Physical Specifications",
      sub: [
        {
          key: "",
          message:
            " Machined aluminum front panel\nMachined aluminum  back panel\nDimmensions: W350xD150xH35\nWeight: approx. 1.6kg ",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    },
    {
      head: "Warranty",
      sub: [
        {
          key: "",
          message: "2-year Norand warranty",
          flag: true
        },
        {
          key: "",
          message: "",
          flag: false
        },
        {
          key: "",
          message: "",
          flag: false
        }
      ]
    }
  ];

  return (
    <>
      <div className="mainTechSpec">
        <div className="technicalSpecHeader">
          <img src={Icon} alt="" className="dropArrowTech" />

          <p className="txtTechSpec"> Technical Specifications</p>
        </div>
        {array.map((item, index) => {
          return (
            <div className="mainTechDetailPart" key={index}>
              <div className="topLineWhite"></div>
              <div className="textTechSpecDetailM">
                <p className="firstTxtTechSpec">{item.head}</p>
                <div className="w100Main">
                  {item.sub.map((data, i) => {
                    return (
                      <div
                        key={i}
                        className={data.flag === true ? "txtPad" : "none"}
                      >
                        <div className="pTopMediumTxt">
                          <p className="mediumTextTech">{data.key}</p>
                        </div>
                        <div className="pTopEndTxt">
                          <p className="txtEndTechSpec">{data.message}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default TechinalSpecificationMK2;
